// eslint-disable-next-line import/prefer-default-export
export function evaluarSiCtaCatastralEsRequerida(empresa) {
  const esCuentaCatastralRequerida = empresa.requiere_cta_catrastral;
  if (esCuentaCatastralRequerida) {
    return {
      labelforFormCatastral: 'Cuenta Corriente Catastral Nro.(OBLIGATORIO)',
      rulesforFormCatastral: [
        { required: true, message: 'Este campo es requerido' }
      ]
    };
  }
  return {
    labelforFormCatastral: 'Cuenta Corriente Catastral Nro. (OPCIONAL)',
    rulesforFormCatastral: []
  };
}
